import React from 'react';
import {} from './withHook.types';
export const withHook = (propName, hookGen) => (Component) => (props) => {
    const hookValue = hookGen(props);
    return React.createElement(Component, { ...props, [propName]: hookValue });
};
